import { getIdTokenResult } from "firebase/auth";
import { profileImagePromises } from '../../storage/storageHelpers';

/** Get the user's token (getIdTokenResult) and imageUrl (storage) */
/**
 * 
 * @param {object} auth 
 * @returns a promise with the result of getIdToken and profileImages
 */
export const getAdditionalAppUserInfoPromise = (mainStorage, mainAuth) => {
  const { currentUser } = mainAuth
  const promises = []
  // get tokens 
  promises.push(getIdTokenResult(currentUser))
  // promises.push(profileImagePromises(mainStorage, currentUser))
  return Promise.all(promises)

}